import type { NotifyPort } from '@/features/messages/domain/notify'
import type { OrgTeamPort } from '../domain/member'

const addMember = async (
	port: OrgTeamPort,
	teamId: string,
	memberId: string,
	notify: NotifyPort,
): Promise<boolean> => {
	try {
		await port.addMemberToTeam(teamId, memberId)
		return true
	} catch {
		notify.error('hr.memberAddFailed')
		return false
	}
}

const removeMember = async (
	port: OrgTeamPort,
	teamId: string,
	memberId: string,
	notify: NotifyPort,
): Promise<boolean> => {
	try {
		await port.removeMemberFromTeam(teamId, memberId)
		return true
	} catch {
		notify.error('hr.memberRemoveFailed')
		return false
	}
}

const addLeader = async (
	port: OrgTeamPort,
	teamId: string,
	memberId: string,
	notify: NotifyPort,
): Promise<boolean> => {
	try {
		await port.addLeaderToTeam(teamId, memberId)
		return true
	} catch {
		notify.error('hr.teamLeadSetFailed')
		return false
	}
}

const removeLeader = async (
	port: OrgTeamPort,
	teamId: string,
	memberId: string,
	notify: NotifyPort,
): Promise<boolean> => {
	try {
		await port.removeLeaderFromTeam(teamId, memberId)
		return true
	} catch {
		notify.error('hr.teamLeadRemoveFailed')
		return false
	}
}

export { addMember, removeMember, addLeader, removeLeader }
